module.exports = __webpack_public_path__ + "static/media/BlockIcon.svg";